module.exports = __webpack_public_path__ + "logo-adyen.83f50a245e3ff57c532e2526d96942d7.svg";